export default class TineDiagramInput {
  constructor(item) {
    if (item) {
      this.weightCategoryId = item.weightCategoryId;
      this.thumbBucketProfileId = item.thumbBucketProfileId;
      this.couplerStyleId = item.couplerStyleId;
      this.productThumb = item.productThumb;
      this.productBucket = item.productBucket;
      return;
    }
    this.weightCategoryId = null;
    this.thumbBucketProfileId = null;
    this.couplerStyleId = null;
    this.productThumb = null;
    this.productBucket = null;
  }
}
